<template>
    <div class="container" v-if="image">
        <figure class="tickets-splash">
            <a v-if="link" class="tickets-splash-link" :href="link">
                <img class="image" :src="image" />
            </a>
            <img v-else class="image" :src="image" />
        </figure>
        <div class="countdown" v-if="countdown" v-bind:style="{ top: countdown.top, left: countdown.left }">
            <countdown :time="countdown.ends">
                <template slot-scope="props">
                    <div class="countdown-items">
                        <div class="days">
                            <div class="number">{{ props.days }}</div> days
                        </div>
                        <div class="hours">
                            <div class="number">{{ props.hours }}</div> hours
                        </div>
                        <div class="minutes">
                            <div class="number">{{ props.minutes }}</div> min
                        </div>
                        <div class="seconds">
                            <div class="number">{{ props.seconds }}</div> sec
                        </div>
                    </div>
                </template>
            </countdown>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .container {
        position: relative;
    }

    .tickets-splash {
        border-radius: 15px;
        overflow: hidden;
        box-shadow: 0 0 5px 5px rgba(0, 0, 0, .1);
    }

    .tickets-splash-link {
        display: block;
    }

    .tickets-splash img {
        display: block;
        margin: 0 auto;
        width: 100%;
    }

    .countdown {
        width: 100%;
        text-align: center;
        font-family: "Lato", sans-serif;
        background: linear-gradient(58deg, #6bdb89 0%, #00c7a6 100%);
        padding: 8px;
        border-radius: 10px;

        @media (min-width: 992px) {
            position: absolute;
            padding: 0 5px;
            width: 18%;
            border-radius: 0;
            background: transparent;
        }
    }

    .countdown-items {
        display: flex;
        margin: 0 auto;
        justify-content: space-between;
        max-width: 860px;
        padding: 19px 10px 12px;
        color: #fff;
        background-color: #000;
        border-radius: 10px;

        @media (min-width: 992px) {
            background-color: transparent;
            border-radius: 0;
            padding: 0;
            margin: 12px auto 0;
        }

        > div {
            width: 25%;
            font-size: 12px;
            text-transform: uppercase;
        }

        .number {
            font-size: 32px;
            line-height: .5em;
            margin-bottom: 6px;
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                image: null,
                link: null,
                countdown: null,
            }
        },

        mounted() {
            this.load()
        },

        methods: {
            handleOptions (options) {
                const deviceWidth = 1100
                const isMobile = this.willBeMobile({ ...options, deviceWidth })

                const image = isMobile ? options.banner_mobile : options.banner_desktop
                const countdown = !options.countdown ? null : {
                    ends: new Date(options.date_end) - new Date(),
                    top: options.position_top,
                    left: options.position_left,
                }

                if (!image) {
                    return false
                }

                this.image = image
                this.link = this.resolveClickUrl(options.click_url)
                this.countdown = countdown
            },

            /**
             * Só torna clicável se houver URL e a página atual ainda não for o destino.
             */
            resolveClickUrl(clickUrl) {
                if (!clickUrl) {
                    return null
                }

                const href = window.location.href
                const path = window.location.pathname

                if (href.includes(clickUrl) || path.includes(clickUrl)) {
                    return null
                }

                try {
                    const target = new URL(clickUrl, window.location.origin)
                    const normalize = (value) => (value.replace(/\/+$/, '') || '/')
                    if (normalize(path) === normalize(target.pathname)) {
                        return null
                    }
                    if (href.includes(target.pathname) && target.pathname !== '/') {
                        return null
                    }
                } catch (e) {
                    // URL relativa inválida: segue com o valor bruto se não bateu nos includes acima
                }

                return clickUrl
            },

            willBeMobile(options) {
                return window.innerWidth <= options.deviceWidth && options.banner_mobile
            },

            getUrlParameter(name) {
                const url = decodeURIComponent(window.location.search.substring(1))
                const queries = url.split('&')

                for (const index in queries) {
                    const [key, value] = queries[index].split('=')

                    if (key === name) {
                        return value === undefined ? true : value
                    }
                }
            },

            load() {
                const promo = this.getUrlParameter('promo') || ''
                const token = this.getUrlParameter('token') || ''
                const page = window.location.pathname;
                const request = axios.get('/api/splash/tickets', {
                    params: {
                        promo, token, page
                    },
                })

                request.then(response => {
                    this.handleOptions(response.data)
                }).catch(error => {
                    console.error(error)
                })
            }
        }
    }
</script>
